import { formatSize } from "utils/files.js";

export default angular.module("vesl.filters.formatFileSize", [])
	.filter("formatFileSize", function() {
		return formatSize;
	})
	.name;
